import {
  FETCH_NOTIFICATION_BANNERS_REQUEST,
  FETCH_NOTIFICATION_BANNERS_SUCCESS,
  FETCH_NOTIFICATION_BANNERS_FAILURE,
  SET_NOTIFICATION_BANNER_LOADING,
  CLEAR_NOTIFICATION_BANNER_ERROR,
  // Add new action types for site notifications
  FETCH_SITE_NOTIFICATIONS_REQUEST,
  FETCH_SITE_NOTIFICATIONS_SUCCESS,
  FETCH_SITE_NOTIFICATIONS_FAILURE,
  FETCH_SITE_NOTIFICATIONS_LOADING,
  // Add save notification action types
  SAVE_SITE_NOTIFICATION_REQUEST,
  SAVE_SITE_NOTIFICATION_SUCCESS,
  SAVE_SITE_NOTIFICATION_FAILURE
} from './actionTypes';

// Fetch notification banners actions
export const fetchNotificationBannersRequest = () => ({
  type: FETCH_NOTIFICATION_BANNERS_REQUEST,
});

export const fetchNotificationBannersSuccess = (payload: any) => ({
  type: FETCH_NOTIFICATION_BANNERS_SUCCESS,
  payload,
});

export const fetchNotificationBannersFailure = (payload: any) => ({
  type: FETCH_NOTIFICATION_BANNERS_FAILURE,
  payload,
});

// Utility actions
export const setNotificationBannerLoading = (payload: boolean) => ({
  type: SET_NOTIFICATION_BANNER_LOADING,
  payload,
});

export const clearNotificationBannerError = () => ({
  type: CLEAR_NOTIFICATION_BANNER_ERROR,
});

// Site notifications actions
export const fetchSiteNotificationsRequest = () => ({
  type: FETCH_SITE_NOTIFICATIONS_REQUEST,
});

export const fetchSiteNotificationsSuccess = (payload: any) => ({
  type: FETCH_SITE_NOTIFICATIONS_SUCCESS,
  payload,
});

export const fetchSiteNotificationsFailure = (payload: any) => ({
  type: FETCH_SITE_NOTIFICATIONS_FAILURE,
  payload,
});

export const fetchSiteNotificationsLoading = (payload: any) => ({
  type: FETCH_SITE_NOTIFICATIONS_LOADING,
  payload,
});

// Save site notification actions
export const saveSiteNotificationRequest = (payload: any) => ({
  type: SAVE_SITE_NOTIFICATION_REQUEST,
  payload,
});

export const saveSiteNotificationSuccess = (payload: any) => ({
  type: SAVE_SITE_NOTIFICATION_SUCCESS,
  payload,
});

export const saveSiteNotificationFailure = (payload: any) => ({
  type: SAVE_SITE_NOTIFICATION_FAILURE,
  payload,
});
